import React from 'react';
import CertificateComp from './CertificateComp';

function Certificate() {
  return (
    <CertificateComp />
  );
}

export default Certificate;
